/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TelemetryEvent } from '../interfaces/telemetry/telemetry-events';
import { Router } from '@angular/router';

import { SeverityError } from '../enum/severity-error';
import { TelemetryAction } from '../interfaces/telemetry/telemetry-action';
import { TelemetrySources } from '../interfaces/telemetry/telemetry-sources';


@Injectable({
  providedIn: 'root'
})
export class TelemetryService {
  private telemetryUrl = environment.TELEMETRY_URL;

  constructor(private http: HttpClient, private route: Router) {
  }

  log(event: TelemetryEvent): void {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Auth-Token': environment.TELEMETRY_KEY
    });

    const processId = sessionStorage.getItem('processId');
    const userFbRaw = sessionStorage.getItem('user');
    const userFb = userFbRaw ? JSON.parse(userFbRaw) : null;


    const payload: TelemetryEvent = {
      timestamp: Date.now(),
      dateYMD: this.formatDateToYMD(new Date()),
      dateTime: this.formatDateTime(new Date()),
      source: 'admin-portal',
      url: this.route.url,
      processId: processId ?? 'unknow',
      userEmail: userFb?.email,
      ...event
    };

    this.http.post(this.telemetryUrl, payload, { headers }).subscribe({
      next: () => console.log('Telemetry sent successfully'),
      error: (err) => console.error('Telemetry error:', err)
    });
  }

  getTelemetryMetadata(): Record<string, any> {
    // Construimos los auth dinámicamente
    const authStates: Record<string, boolean> = {
      classlinkAuth: sessionStorage.getItem('classlinkAuth') === 'true',
      cleverAuth: sessionStorage.getItem('cleverAuth') === 'true',
      microsoftAuth: sessionStorage.getItem('microsoftAuth') === 'true',
      googleAuth: sessionStorage.getItem('googleAuth') === 'true'
    };

    // Solo incluimos los que son true
    const authMetadata: Record<string, boolean> = {};
    Object.entries(authStates).forEach(([key, value]) => {
      if (value) authMetadata[key] = true;
    });

    return {
      // Agregamos solo auths verdaderos
      ...authMetadata,
      browserVersion: navigator.userAgent,
      os: navigator.platform,
      language: navigator.language,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  }

  getOperationName(gqlInstance: any): string | undefined {
    const def = gqlInstance.document.definitions.find(
      (d: any) => d.kind === 'OperationDefinition'
    );
    return def?.name?.value;
  }

  formatDateToYMD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 porque los meses van de 0 a 11
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  }

  logError(error: any, telemetryActionData?: TelemetryAction, severity?: SeverityError,
           telemetrySources?: TelemetrySources): void {  
       const extractMessage = this.extractErrorMessage(error);
       if (extractMessage) {
                const error = {
                  severity:  severity?.toString()?? 'ERROR',
                  description: extractMessage,
                  actionData: telemetryActionData,
                  metadata: this.getTelemetryMetadata(),
                  classId: telemetrySources?.classId,
                  districtId:  telemetrySources?.districtId,
                  schoolId: telemetrySources?.schoolId
          } as TelemetryEvent;

          this.log(error);                     
       }
  }

  formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}/${month}/${day}T${hours}:${minutes}:${seconds}`;
  }

  generateProcessId(): string {
    const datePart = new Date().toISOString().replace(/[:.-]/g, '');
    const randomPart = Math.random().toString(36).substring(2, 10);
    return `process-${datePart}-${randomPart}`;
  }

  extractErrorMessage(error: any): string {
    if (!error) return 'Unknown error';

    if (Array.isArray(error?.graphQLErrors) && error?.graphQLErrors?.length > 0) {
      return error?.graphQLErrors
        .map((e: any) => e?.message || e?.extensions?.message || 'Unknown GraphQL error')
        .join(', ');
    }
   
    if (error?.networkError) {     
      const networkMsg =
        error.networkError?.message ||
        error.networkError?.statusText ||
        (error.networkError?.result?.errors?.[0]?.message ?? '');
      return networkMsg || 'Network error';
    }

   if (error?.message) return error.message;

   if (error?.body?.message) return error.body.message;

    return typeof error === 'string' ? error : JSON.stringify(error);
  }

}
